<template>
  <div class="contactApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='6'></headComponent>
    <div class="h"></div>
    <div class="proBg"  style="background: url(https://www.boyagongdao.com/public/storage/upload/files/20230922/07ec978fd672bb6fde9ece831560cc1b.png) no-repeat center;">
      <div class="txt">
        <h2 class="tit">沧龙出海，智慧赋能，以卓越装备，谱写海洋科技新篇</h2>
        <h2 class="tit">0771-5383552</h2>
        <div class="desc">
          <p>CLKJ@zhjtg.com</p>
          <p style="padding:12px 0">广西钦州市钦南区大番坡镇金窝工业园区一期</p>
          <img style="width:120px" src="~assets/images/code.jpg">
        </div>
      </div>
    </div>
    <div class="main">
      <ul>
        <li>
          <h2><span>开放合作</span></h2>
          <div class="con">
            <p>我们致力于成为区内一流的海洋智慧装备综合服务商，以技术及服务创新推动海洋经济与水域安全事业的进步。我们期待与以下伙伴携手，合作发展：</p>
            <p>政府机构：联合申报智慧海洋、应急管理专项，共建示范项目；</p>
            <p>产业龙头：与能源、航运企业合作定制化解决方案；</p>
            <p>科研院校：推动技术联合攻关与人才输送；</p>
            <p>投资人：以稳健的财务模型和清晰的退出路径，共享增长红利。</p>
            <p>从水域到浅海，从检测到救援，我们正以智能科技重塑人类与水的链接。</p>
            <p>期待与您同行，探索浩渺深蓝，共赢千亿未来！</p>
          </div>
        </li>
        
      </ul>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setJob:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .contactApp .el-message-box{
    width:30%
  }
  .contactApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .contactApp .h{
    height:96px
  }
  .contactApp .proBg{
    height: 35.06vw;
    color:#fff;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .contactApp .proBg .txt{
    position: absolute;
    top: 50%;
    color: #fff;
    transform: translateY(-50%);
    width:100%;
    text-align:center;
  }
  .contactApp .proBg .txt .tit{
    font-size: 3vw;
    margin-bottom:20px;
    font-weight: normal;
  }
  .contactApp .proBg .txt .desc {
    font-size: 15px;
  }


  .contactApp .main{
    max-width: 1600px;
    margin: 0 auto 25px auto
  }
  .contactApp .main .txt p{
    text-indent: 2em;
    font-size: 16px;
    color: #333;
    line-height: 25px;
    padding-top: 5px 
  }
  .contactApp .main li{
    background: #fff;
    padding-bottom: 15px;
    margin-top: 15px
  }
  .contactApp .main li h2 {
    height: 50px;
  }
  .contactApp .main li h2 span{
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #15499a;
    margin-left: 18px;
  }
  .contactApp .main li h2 font{
    float: right;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #666;
    margin-right: 15px;
  }
  .contactApp .main li .con{
    width: 96%;
    margin: auto;
    display: block;
    font-size: 16px;
    color: #333;
  }
  .contactApp .main li .con *{
    font-size: 16px;
    line-height: 22px;
    padding-top: 8px
  }

  
  @media only screen and (max-width: 1199px) {
    .contactApp .header,.contactApp .h{
      height:60px;
    }
    .contactApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .contactApp .header .nav{
      text-align:right
    }
    .contactApp .header .nav li{
      margin:0 1.8vw
    }
    .contactApp .header .nav .close{
      display:none
    }
    .contactApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .contactApp .proBg{
      font-size:18px;
    }
    .contactApp .main dl dd{
      width:50%
    }
  } 
</style>